export default function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/shared/classes-to-selector.js
// module id = 11
// module chunks = 0 1